module.exports = __webpack_public_path__ + "assets/measure_vehicle_oil_life.9e89e1ad.svg";